import React from "react";
import "./departure.css";

const Departure = ({cl}) => {
  return (
    <div className={cl}>
      <h2>Thank You</h2>
      <p>
        Thank you for taking the time to look at my portfolio and to consider me
        for your available role. I look forward to hearing from you! <br></br> Have a
        nice day.
      </p>
    </div>
  );
};

export default Departure;
